import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import GoablDevice from '../../components/GoablDevice'

const { Cell } = ResponsiveGrid;
function getObj(){
   
  return {
    display :true 
  }


}

const CommunityDevice = () => (
  
 
  <ResponsiveGrid gap={20}>
  
    <Cell colSpan={12}>
      <PageHeader
        title="設備列表"
   
        breadcrumbs={[
          {
            name: '設備管理',
          },
          {
            name: '設備列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>

    <GoablDevice data={getObj()}/>
    
    </Cell>
  </ResponsiveGrid>
);

export default CommunityDevice;
